import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonDialogSettings } from '../common-dialog-settings.interface';

@Component({
    selector: 'app-progress-dialog',
    templateUrl: './progress-dialog.component.html',
    standalone: false,
})
export class ProgressDialogComponent implements OnInit {
    public innerWidth: number;

    public constructor(
        public dialogRef: MatDialogRef<ProgressDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public settings: CommonDialogSettings
    ) {}

    public ngOnInit(): void {
        this.innerWidth = window.innerWidth;
    }
}
